<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
    <div class="row">
      <div class="col-12"></div>
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <!-- ngx-datatable-filter -->
              <fieldset class="form-group">
                <div class="row align-items-end mt-0 pagination-body">
                    <div class="col-12 col-sm-12 col-md-8 col-lg-4 mb-2">
                        <div class="btn-group enrollment-list-btn-info" role="group">
                          <button type="button" class="btn"
                          [ngClass]="{'btn-primary':activeTab=='Text','btn-outline-primary':activeTab!='Text'}"
                          (click)="activeAppTab(activeTab=='Text'?'':'Text',0)">Text</button>
                          <button type="button" class="btn"
                            [ngClass]="{'btn-primary':activeTab=='Image','btn-outline-primary':activeTab!='Image'}"
                            (click)="activeAppTab(activeTab=='Image'?'':'Image',0)">Image</button>
                          <button type="button" class="btn"
                            [ngClass]="{'btn-primary':activeTab=='Video','btn-outline-primary':activeTab!='Video'}"
                            (click)="activeAppTab(activeTab=='Video'?'':'Video',0)">Video</button>
                          <button type="button" class="btn"
                            [ngClass]="{'btn-primary':activeTab=='All','btn-outline-primary':activeTab!='All'}"
                            (click)="activeAppTab(activeTab=='All'?'':'All',0)">All</button>
                         
                        </div>
                      </div>
                  <div class="col-12 col-sm-12 col-md-8 col-lg-8 mt-2 mb-1">
                    <div class="row-flex">
                      
                      <div class="col-flex-2 mb-1">
                        <ng-select style="width: 250px;"  [items]="tag_cat_list" bindLabel="displayname" bindValue="_id" placeholder="Select Tag"
                          [(ngModel)]="selected_tag_cat_id" [ngModelOptions]="{ standalone: true }"
                          (change)="getTagCatId($event)" >
                        </ng-select>
                      </div>
                      <div class="col-flex-2 mb-1 position-relative">
                        <input id="ngx-filter-ref"
                          class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                          type="text" placeholder="Search" #name (keydown.enter)="getTagsFilter(searchVal)"
                          [(ngModel)]="searchVal" />
                        <button class="btn search-btn glow position-absolute" (click)="getTagsFilter(searchVal)">
                          <i class="ft-search text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <div class="col-flex-2 mb-1">
                        <button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">
                          Reset
                          <i class="ft-filter text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <div class="col-flex-2 mb-1"
                        *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                        <button class="btn btn-primary btn-block users-list-clear glow mb-0"
                           placement="top" ngbTooltip="Add New" (click)="addApp(activeTab)" data-toggle="modal" data-target="#app-model">
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-2 mb-1">
                      <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
                    [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
                    [count]="page.totalPages" [offset]="page.pageNumber"
                    (page)="pageChangeData($event)"></ngx-datatable>
                  </div>
                 
                  <div class="col-12">
                    <div class="row">
                      <div class="col-3">
                        <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Content Apps Guideline</button>
                      </div>
                       <div class="col-3">
                        <ng-select  [items]="courses" bindLabel="title" bindValue="_id" placeholder="Select Course"
                          [(ngModel)]="selected_course_id" [ngModelOptions]="{ standalone: true }"
                          (change)="getCourseId($event)" >
                        </ng-select>
                      </div>
                    </div>
                    </div>
                </div>
              
              </fieldset>
              <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
                [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
                [columns]="columns" [externalPaging]="true" [count]="page.totalPages" [offset]="page.pageNumber"
                (page)="pageChangeData($event)">
                <ngx-datatable-column name="Title" prop="name" [width]="100">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="d-flex align-items-center">
                      
                      <!-- <div *ngIf="!row.image" class="avatar mr-1 ml-0 bg-primary">
                        <div class="avatar-content">
                          {{ row?.name | shortName }}
                        </div>
                      </div> -->
                      <div class="cell-line-height cursor-pointer" >
                        <p class="font-medium-1 line-height-1 mb-0">
                          {{ row?.name }}
                        </p>
                      </div>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Tags" prop="app_status" [width]="20">
                  
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <p (click)="openStatusModal(statuspopup,row)">

                    <span *ngFor="let status of row?.app_status">
                      <span *ngIf="status.displayname == 'Duplicate'" 
                      [ngClass]="{'bg-light-danger badge badge-pill cursor-pointer':status.displayname == 'Duplicate'}">
                      {{status.displayname}}
                      </span>
                      <span *ngIf="status.displayname == 'Verified'" 
                      [ngClass]="{'bg-light-success badge badge-pill cursor-pointer':status.displayname == 'Verified'}">
                      {{status.displayname}}
                      </span>
                      <span *ngIf="status.displayname == 'Unverified'" 
                      [ngClass]="{'bg-light-warning badge badge-pill cursor-pointer':status.displayname == 'Unverified'}">
                      {{status.displayname}}
                      </span>
                    </span>
                    <!-- <span *ngIf="row?.app_status[0]?.displayname == 'Verified'"
                          [ngClass]="{'bg-light-success badge badge-pill cursor-pointer':row?.app_status[0]?.displayname == 'Verified'}">
                          {{row?.app_status[0]?.displayname}}
                          </span>
                          <span *ngIf="row?.app_status[0]?.displayname == 'Unverified'"
                          [ngClass]="{'bg-light-warning badge badge-pill cursor-pointer':row?.app_status[0]?.displayname == 'Unverified'}">
                          {{row?.app_status[0]?.displayname}}
                          </span>
                          <span *ngIf="row?.app_status[0]?.displayname == 'Duplicate'"
                          [ngClass]="{'bg-light-danger badge badge-pill cursor-pointer':row?.app_status[0]?.displayname == 'Duplicate'}">
                          {{row?.app_status[0]?.displayname}}
                          </span> -->
                    </p>
                    <!-- <mat-menu #status="matMenu">
                    <div *ngFor="let status of status_list">
                      <button mat-menu-item *ngIf="status?._id !== row?.app_status[0]?._id"
                      (click)="updateStatus(row._id,status._id)">
                      <span>
                      <span [ngClass]="{'bg-light-success badge badge-pill cursor-pointer':status.displayname == 'Verified'}"
                        placement="top" *ngIf="status.displayname == 'Verified'">{{status.displayname}}</span>
                      <span [ngClass]="{'bg-light-warning badge badge-pill cursor-pointer':status.displayname == 'Unverified'}"
                        placement="top" *ngIf="status.displayname == 'Unverified'">{{status.displayname}}</span>
                      <span [ngClass]="{'bg-light-danger badge badge-pill cursor-pointer':status.displayname == 'Duplicate'}"
                        placement="top"
                        *ngIf="status.displayname == 'Duplicate'">{{status.displayname}}</span>
                      </span>
                      </button>
                      </div>
                    </mat-menu> -->
                    </ng-template>
                  </ngx-datatable-column> 
                <ngx-datatable-column name="Connection" prop="topicCount" [width]="80">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="cell-line-height cursor-pointer" (click)="openModal(myModal,row?.courses)">
                      {{ row?.topicCount}}
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Key" prop="key" [width]="120" *ngIf="activeTab =='Image'">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="cell-line-height">
                      {{ row?.key}}
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Url Link" prop="url_link" [width]="120" *ngIf="activeTab =='Video'">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="cell-line-height">
                      {{ row?.url_link}}
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Content" prop="content" [width]="120" *ngIf="activeTab =='Text'">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="cell-line-height">
                      <p id="content-text" [innerHTML]="row?.content | slice:0:120"></p>  
                      <!-- <p>{{row?.content | slice:0:120}} <span *ngIf="row?.content.length>120">...</span></p>   -->

                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Type" prop="type" [width]="40">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="cell-line-height">
                      {{ row?.type }}
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Actions" [width]="40"
                  *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <i class="ft-edit text-primary cursor-pointer mr-2" data-toggle="modal" data-target="#app-model" (click)="editApp(row)"></i>
                    <i *ngIf="user_role.roles =='admin'" class="ft-trash-2 cursor-pointer danger" (click)="confirmDelete(row._id)"
                      ></i>
                    <i placement="top" ngbTooltip="check app connection" class="ft-settings cursor-pointer text-primary mx-2" (click)="checkConnection(row._id)"
                    ></i>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
              <!-- ngx-datatable-filter -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--/ Filter Datatables -->


  <app-lms-content-editor #modalRef (closeModal)="closeModel()" [appType]="appType" [selectedApp]="selectedApp"></app-lms-content-editor>




  <div class="d-flex justify-content-between align-items-center">
    <ngx-spinner></ngx-spinner>
  </div>

  <!--------------  Popup ------------------------------------------->
<div>
	<ng-template #myModal let-modal>
		<div class="modal-header">
			<h4 class="modal-title">Connected Details</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<form>
				<div class="form-group">
          <div class="form-group">
            <p>Course : <span *ngFor="let item of connected_courses; last as isLast">{{item?.title}} <span *ngIf="item?.title?.length>1 && !isLast">,</span></span> </p>
          </div>
				</div>
			</form>
			
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
			<!-- <button type="button" class="btn btn-primary" (click)="submit()">Submit</button> -->

		  </div>
	</ng-template>
</div>

 <!-------------- Update Status  Popup ------------------------------------------->
 <div>
	<ng-template #statuspopup let-modal>
		<div class="modal-header">
			<h4 class="modal-title">Update Status</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<form>
				<div class="form-group">
          <div class="form-group">
            <ng-select  [items]="status_list" bindLabel="displayname" bindValue="_id" placeholder="Select Tag"
              [(ngModel)]="selected_status" [ngModelOptions]="{ standalone: true }" [multiple]="true"
              (change)="getStatusId($event)" [appendTo]="'body'" [virtualScroll]="true" [clearSearchOnAdd]="true">
            </ng-select>
          </div>
				</div>
			</form>
			
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
			<button type="button" class="btn btn-primary" (click)="updateStatus()">Submit</button>

		  </div>
	</ng-template>
</div>
